import sdl from '@jds/react-generated-sdl/JDSMenuBlockInternal';
import type { JDSMenuBlockInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMenuBlockInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { open = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { open, ...rest },
    'JDSMenuBlockInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MenuBlockInternal = withLogic(
  Component
) as React.FC<JDSMenuBlockInternalProps> & { slotName?: string };

MenuBlockInternal.displayName = 'MenuBlockInternal';
MenuBlockInternal.slotName = 'jds_menu_block_internal';

export { MenuBlockInternal, type JDSMenuBlockInternalProps };
